<template>
  <div id="download">
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">下载库存 </li>
</ul>
</div>
</div>

<div style="height:20px"></div>
<div style="margin:0 auto" class="widu">
EXCEL

{{tips}}
<a v-bind:href="excel" v-if="level" target="_blank" download="" style="font-size:20px">点击下载天然钻石表</a>



</div>


<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                             <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>


  </div>
</template>

<script>

export default {
  name: 'Download',
  data(){
  return {
  token:localStorage.authorization,
  level:0,
  excel: '' ,
  tips:'',
  url:"https://www.giazh.com/auth/download"
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
     downloadData: function () {
         
        this.$http.post(this.url,{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);

	      this.excel="https://www.giazh.com/"+data.body.content;
	      this.level=data.body.level;
	       this.tips=data.body.tips;

	    }).catch(err => {
				console.log(err);
				localStorage.clear();
				alert('已退出');
				window.location.reload(true);
			      }); 

     }
  },
  components:{
  },
  created(){
     if(this.token){
		 this.downloadData();
		 }else{
		 this.tips="请登录后下载";
		 }
  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}

</style>


// WEBPACK FOOTER //
// src/components/Download.vue